import React from 'react';

function GenericFile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="25"
      viewBox="0 0 18 25"
      fill="none"
    >
      <path
        d="M1.5 0.0390625C0.675 0.0390625 0 0.714063 0 1.53906V22.5391C0 23.3641 0.675 24.0391 1.5 24.0391H16.5C17.325 24.0391 18 23.3641 18 22.5391V6.03906L12 0.0390625H1.5Z"
        fill="#EADDFF"
      />
      <path
        d="M13.5 6.03906H18L12 0.0390625V4.53906C12 5.36406 12.675 6.03906 13.5 6.03906Z"
        fill="#6930CA"
      />
      <path d="M18 10.5391L13.5 6.03906H18V10.5391Z" fill="#D5BCFF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 17.0004C15 17.3318 14.7314 17.6004 14.4 17.6004H3.6C3.26863 17.6004 3 17.3318 3 17.0004C3 16.669 3.26863 16.4004 3.6 16.4004H14.4C14.7314 16.4004 15 16.669 15 17.0004Z"
        fill="#9370CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 13.8002C15 14.1316 14.7314 14.4002 14.4 14.4002H3.6C3.26863 14.4002 3 14.1316 3 13.8002C3 13.4688 3.26863 13.2002 3.6 13.2002H14.4C14.7314 13.2002 15 13.4688 15 13.8002Z"
        fill="#9370CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 10.6C15 10.9314 14.7314 11.2 14.4 11.2H3.6C3.26863 11.2 3 10.9314 3 10.6C3 10.2686 3.26863 10 3.6 10H14.4C14.7314 10 15 10.2686 15 10.6Z"
        fill="#9370CF"
      />
    </svg>
  );
}

export default GenericFile;
